export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_06.b894d107.jpg";